var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('add',{attrs:{"show-header":false,"is-editor":"","show-member-tips":"","show-background-color":false}})}
var staticRenderFns = []

export { render, staticRenderFns }